import React, {useEffect, useState} from 'react';
import TextField from '@material-ui/core/TextField';
import {makeStyles} from '@material-ui/core/styles';
import {getClient} from "./utils";

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0)
        },
        '& .MuiFormLabel-root': {
            fontSize: "16px"
        },
        '& .MuiInputBase-root': {
            fontSize: "16px"
        },
        '& .MuiFormHelperText-root': {
            fontSize: "1rem"
        }
    },
}));

const MIN_AMOUNT = 100;
const MIN_PHONE_LEN = 10;

const TOKEN = process.env.REACT_APP_SAMA_AUTHORIZATION; // Test

export default function SamaMoneyForm(props) {
    const classes = useStyles();
    const [phoneClient, setPhoneClient] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState('');
    const [showAmount, setShowAmount] = useState(false);
    const [error, setError] = useState(null);
    const [disabled, setDisabled] = useState(true);
    const [processing, setProcessing] = useState(false);
    const [succeeded, setSucceeded] = useState(false);
    const [orderId, setOrderId] = useState('');
    const [clientName, setClientName] = useState('Djamma Sama Money Payment');

    document.title = clientName

    const authorization = TOKEN;

    const createPayment = async () => {
        // Create PaymentIntent as soon as the page loads
        let body = {
            phoneClient,
            amount,
            description
        };
        if (orderId) {
            body['orderId'] = orderId;
        }
        return fetch("/api/samamoney/payment", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${authorization}`,
                "x-metadata-origin": window.location.hostname
            },
            body: JSON.stringify(body)
        })
            .then(res => {
                return res.json();
            });
    };

    const retrieveClientInformation = async () => {
        if (authorization && authorization.length > 0) {
            let data = await getClient(`/api/samamoney/client`, authorization)
            if (data.code && data.code / 100 !== 2) {
                setError(data);
            } else {
                setClientName(data.name);
            }
        }
    }

    const retrieveInformation = () => {
        if (authorization && authorization.length > 0) {
            setShowAmount(false);
            if (orderId && orderId.length > 0) {
                setShowAmount(false);
                fetch(`/api/samamoney/complete?orderId=${orderId}`, {
                    headers: {
                        "Accept": "application/json",
                        "Authorization": `Bearer ${authorization}`
                    }
                })
                    .then(res => {
                        if (res.status !== 200) {
                            return Promise.reject(res)
                        }
                        return res.json();
                    })
                    .then(data => {
                        console.log('data', data);
                        setAmount(data.amount);
                        setDescription(data.description);
                        setPhoneClient(data.phoneClient);
                        setSucceeded(data.success);
                        setDisabled(false);
                    })
                    .catch(error => {
                        console.log('error', error);
                        setShowAmount(true);
                    });
            } else {
                setShowAmount(true);
            }
        }
        retrieveClientInformation();
    }

    useEffect(retrieveInformation, []);

    const handleSubmit = (ev) => {
        ev.preventDefault();
        setProcessing(true);
        createPayment().then(res => {
            console.log('res', res);
            if (res.code) {
                setError(`Payment failed ${res.message || res.description}`);
                setProcessing(false);
            } else {
                setError(null);
                setProcessing(false);
                setDisabled(true);
                let entity = res;
                if (entity.entity) {
                    entity = entity.entity
                }
                setOrderId(entity.orderId);
                if (!entity.success) {
                    setError(entity.message)
                }
                if(typeof props.onSuccess === 'function') {
                    props.onSuccess(entity);
                }
            }
        }).catch(error => {
            console.log('error', error);
            setError(`Payment failed ${error.message}`);
            setProcessing(false);
        });
    }
    return (
        <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
            <h1>{clientName}</h1>
            {orderId && <h2>Order Id : {orderId}</h2>}
            <TextField fullWidth
                       id="standard-error"
                       label="Phone Number"
                       placeholder={"22391445058"}
                       required
                       value={phoneClient}
                       disabled={succeeded}
                       onChange={e => {
                           setPhoneClient(e.target.value);
                           setDisabled(e.target.value.length < MIN_PHONE_LEN)
                       }}
            />
            <TextField fullWidth
                       id="standard-error"
                       label="Montant"
                       placeholder={"10 000 FCFA"}
                       required
                       type={"text"}
                       value={amount}
                       disabled={!showAmount || succeeded}
                       onChange={e => {
                           setAmount(Boolean(e.target.value) ? (e.target.value * 1) : '')
                           setDisabled(e.target.value * 1 < MIN_AMOUNT)
                       }}
            />
            <TextField fullWidth
                       id="standard-error"
                       label="Description"
                       value={description}
                       disabled={succeeded}
                       onChange={e => {
                           setDescription(e.target.value)
                       }}
            />

            <button
                disabled={processing || disabled || succeeded}
                id="submit"
            >
                <span id="button-text">
                  {processing ? (
                      <div className="spinner" id="spinner"></div>
                  ) : (
                      "Sama Money Payment"
                  )}
                </span>
            </button>
            {/* Show any error that happens when processing the payment */}
            {error && (
                <div className="card-error" role="alert">
                    {error}
                </div>
            )}
            {/* Show a success message upon completion */}
            <p className={succeeded ? "result-message" : "result-message hidden"}>
                Payment complété. Merci !
            </p>
        </form>
    );
}